import { CustomTextField, CustomSelect, CustomRadio, CustomCheckbox, CustomDatePicker, ChipsInput, SearchInput, EditCustomTextField, CustomComponent, CustomDateRangePicker } from "../inputfields/form-elements";

export const FIELD_COMPONENTS: Record<string, React.FC<any>> = {
    text: CustomTextField,
    number:CustomTextField,
    select: CustomSelect,
    radio: CustomRadio,
    checkbox: CustomCheckbox,
    date: CustomDatePicker,
    dateRange: CustomDateRangePicker,
    chips: ChipsInput,
    search: SearchInput,
    editText:EditCustomTextField,
    component:CustomComponent,
  };